// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"8675c7bc","496":"848cd013","576":"ca4b2c15"}[chunkId] + ".chunk.js";
};